import { IConfigurationFormatted } from '../../types/project';
import { IApplicationState } from '../../types/redux';
import { formatPrice } from '../../utils/formatters/price';

export const selectConfigurations = (state: IApplicationState): IConfigurationFormatted[] => {
  return state.projectData.project.configurations.map(({ price, ...rest }) => {
    return {
      ...rest,
      price: price ? formatPrice(price) : undefined,
    };
  });
};
